import { Fragment } from "react";
import {Grid, Typography } from '@material-ui/core';
import { addCommas } from "../../../data-display/data-display.component";

const AreaInfo = ({ mapBlock, assessorBlock, area}) => {
  const {
    S_Current_Gross_Total_Area,
    S_Current_Excluded_Area,
    S_Current_Permeable_Area,
    S_Current_Impermeable_Area
  } = area;

  return (
    <Fragment>
      <Grid item xs={4} align="center">
        <Typography variant="h6" color="textPrimary">
          {mapBlock}
        </Typography>
        <Typography variant="body2">Map Block Lot</Typography>
      </Grid>
      <Grid item xs={4} align="center">
        <Typography variant="h6" color="textPrimary">
          {assessorBlock}
        </Typography>
        <Typography variant="body2">Assessor Block Lot</Typography>
      </Grid>
      <Grid item xs={4} align="center">
        <Typography variant="h6" color="textPrimary">
          {addCommas(Math.round(S_Current_Gross_Total_Area))}
        </Typography>
        <Typography variant="body2">Current Gross Total Area</Typography>
      </Grid>
      <Grid item xs={4} align="center">
        <Typography variant="h6" color="textPrimary">
          {addCommas(Math.round(S_Current_Excluded_Area))}
        </Typography>
        <Typography variant="body2">Current Excluded Area</Typography>
      </Grid>
      <Grid item xs={4} align="center">
        <Typography variant="h6" color="textPrimary">
          {addCommas(Math.round(S_Current_Permeable_Area))}
        </Typography>
        <Typography variant="body2">Current Permeable Area</Typography>
      </Grid>
      <Grid item xs={4} align="center">
        <Typography variant="h6" color="textPrimary">
          {addCommas(Math.round(S_Current_Impermeable_Area))}
        </Typography>
        <Typography variant="body2">Current Impermeable Area</Typography>
      </Grid>
    </Fragment>
  )
}

export default AreaInfo;